<template>
  <el-form :inline="true" class="demo-form-inline">
    <el-form-item label="栏目名称">
      <el-input v-model="searchForm.name" placeholder="请输入栏目名称"></el-input>
    </el-form-item>
    <el-form-item>
        <el-button type="primary" @click="search()">搜索</el-button>
        <el-button type="primary" @click="showAdd()">新建</el-button>
        <el-button type="primary" @click="getList()">刷新</el-button>
    </el-form-item>
    
  </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="栏目" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="180">
        <template #default="scope">
          <div>
            <span>{{typeFilter(scope.row.type)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="资源路径" width="180" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{scope.row.resource}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="100">
        <template #default="scope">
          <div>
            <span>{{ scope.row.seq }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.createTime }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--新建 -->
    <el-dialog v-model="dialogFormVisible" title="新建栏目" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
        <el-form ref="addFormRef" :model="addInfo" :rules="addRules" label-position="right" label-width="auto">
        <el-form-item label="栏目名称" prop="name">
            <el-input v-model="addInfo.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="类型" prop="type">
            <el-select v-model="addInfo.type" placeholder="请选择类型">
            <el-option label="菜单" value="MENU" />
            <el-option label="按钮" value="BUTTON" />
            <el-option label="API" value="API" />
            </el-select>
        </el-form-item>
        <el-form-item label="权限标识" prop="code">
            <el-input v-model="addInfo.code" autocomplete="off" />
        </el-form-item>
        <el-form-item label="菜单图标">
            <el-input v-model="addInfo.icon" autocomplete="off" />
        </el-form-item>
        <!-- <el-form-item label="所属菜单">
            <el-select v-model="addInfo.parentId" placeholder="请选择所属菜单">
            <el-option v-for="(item,index) in firstMenu" :label="item.name" :value="item.id" />
            <el-option label="无" value="0" />
            </el-select>
        </el-form-item> -->
        <el-form-item label="所属菜单">
          <el-tree-select
            v-model="addInfo.parentId"
            :data="treeData"
            check-strictly
            :render-after-expand="false"
            show-checkbox
          />
        </el-form-item>
        <el-form-item label="资源路径">
            <el-input v-model="addInfo.resource" autocomplete="off" />
        </el-form-item>
        <el-form-item label="排序" prop="seq">
            <el-input v-model="addInfo.seq" autocomplete="off" />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="save()">保存</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该权限栏目？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteRole()">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>
  import { ElMessage } from 'element-plus'
  import { required, isNumber, isAlphanumeric } from '@/utils/validators';

  export default {
  name:'LimitsManage',
  data() {
    return {
        searchForm:{
          name: '',
        },
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        is_update:0, //编辑/新增
        dialogFormVisible:false,
        firstMenu:[],
        treeData:[
          // {
          //   id:'',
          //   label:'无',
          //   value:'',
          //   children:[]
          // }
        ],
        tableData:[
            //  {
            //     "id": 1,
            //     "name": "设备管理",
            //     "type": "MENU",
            //     "resource":'', //路径、资源
            //     "parentId": 0,
            //     "seq": 0,
            //     "children": []
            //   }
        ],
        addFormRef: null,
        addRules: {
          name: [required('请输入栏目名称')],
          type: [required('请选择类型')],
          code: [required('请输入权限标识'), isAlphanumeric('权限标识只能输入数字或字母')],
          seq: [isNumber('排序只能输入数字')],
        },
        addInfo:{
            name: '',
            type: '',
            code: '',
            icon: '',
            resource: '',
            seq: '',
            parentId: '',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数  
    }
  },
  computed: {
    filteredMessage() {
      // 这里可以实现类似过滤器的转换逻辑
    }
  },
  beforeCreate(){
    
  },
  created(){
    
  },
  mounted(){
    this.getList();
    this.getTreeList();
  },
  methods:{
    handleSizeChange (val) { //每页显示条数
        this.pageSize = val;
        this.currentPage = 1;
        this.getList();
    },
    handleCurrentChange(val) { //当前页
        this.currentPage = val;
        this.getList(); //获取列表
    },
    search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.name = that.searchForm.name;
        that.$axios.post(that.$store.state.platformApi+"permission/page",JSON.stringify(param)).then(result => {
          // console.log(result);
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total; //总条数
            that.firstMenu = that.tableData.filter(item=>{
              return item.parentId==0
            });
            // console.log(that.firstMenu);
          }
        })
      },
    getList(){
      //获取权限列表
      let that = this;
      let param = {};
      param.page = this.currentPage;
      param.pageSize = this.pageSize;
      that.$axios.post(that.$store.state.platformApi+"permission/page",JSON.stringify(param)).then(result => {
        // console.log(result);
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total; //总条数
          that.firstMenu = that.tableData.filter(item=>{
            return item.parentId==0
          });
          // console.log(that.firstMenu);
        }
      })
    },
    getTreeList(){
      //获取权限树状图
      let that = this;
      let param = [];
      that.$axios.post(that.$store.state.platformApi+"permission/all",JSON.stringify(param)).then(result => {
        // console.log(result);
        if(result.code==200){
          if(result.data.length>0){
            that.treeData = result.data.map(item => ({
              value: item.id,
              label: item.name,
              children: item.children ? item.children.map(item2 => ({
                value: item2.id,
                label: item2.name,
                children:[]
                // children: item2.children ? item2.children.map(item3 => ({
                //   value: item3.id,
                //   label: item3.name,
                //   children: item3.children ? item3.children.map(item4 => ({
                //     value: item4.id,
                //     label: item4.name,
                //   })) : []
                // })) : []
              })) : []
            }));
          }
          that.treeData.unshift({
            value: 0,
            label: '无',
            children: []
          });
        }
      })
    },
    save(){
      //保存
      let that = this;
      // 表单校验
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        if(that.is_update==1){
          //编辑
          var url = that.$store.state.platformApi+"permission/edit";
        }else{
          //新增
          var url = that.$store.state.platformApi+"permission/add";
        }
        that.$axios.post(url,JSON.stringify(that.addInfo)).then(result => {
          if(result.code==200){
            // 保存成功
            that.dialogFormVisible = false;
            that.getList();
            ElMessage({
              message: '保存成功',
              type: 'success',
            })
          }
        })
      });
    },
    deleteRole(){
      //删除权限
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"permission/delete/"+that.currt_id).then(result => {
        // console.log(result);
        if(result.code==200){
          that.centerDialogVisible = false;
          that.firstMenu = that.firstMenu.filter(item=>{
            return item.id!=that.currt_id
          });
          that.tableData = that.tableData.filter(item=>{
            return item.id!=that.currt_id
          });
          // that.getList();
          ElMessage({
            message: '已删除权限',
            type: 'success',
          })
        }
      })
    },
    showAdd(){
        this.is_update = 0;
        this.addInfo = Object.fromEntries(
          Object.keys(this.addInfo).map(key => [key, ''])
        );
        this.dialogFormVisible = true;
    },
    handleEdit(index,row){
      let that = this;
      that.is_update = 1;
      that.$axios.post(that.$store.state.platformApi+"permission/view/"+row.id).then(result => {
        // console.log(result);
        if(result.code==200){
          that.addInfo = result.data;
          that.dialogFormVisible = true;
        }
      })
    },
    handleDelete(index,row){
        // console.log(row);
        this.centerDialogVisible = true;
        this.currt_id = row.id;
    },
    typeFilter(value) {
      //过滤函数
      if(value=='MENU'){
        return '菜单'
      }
    },
    // menuFilter(value) {
    //   //过滤函数
    //   if(value=='MENU'){
    //     return '菜单'
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
</style>